import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.recent-posts__items');
  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      gap: 73,
      arrows: true,
      pagination: false,
      keyboard: 'global',
      rewind: false,
      trimSpace: true,
      focus: 0,
      omitEnd: true,
      adjustableHeight: {
        whileSliding: true,
        speed: '0.4s',
      },

      breakpoints: {
        1200: {
          perPage: 3,
          gap: 35,
        },
        1023: {
          perPage: 2,
          gap: 35,
        },
        768: {
          perPage: 1,
          gap: 0,
        },
      },
    });

    splide.mount({ AdjustableHeight });
  }
});
